import React, { FC, useContext, useEffect, useState } from 'react';

import { GlobalContext } from '../../../../store';
import { IClub } from '../../../../store/player/clubs/store';

import EventToday from '../../ClubHome/EventToday/EventToday';

const AllClubsEventToday: FC = () => {
  const { clubs } = useContext(GlobalContext);

  const [allClubs, setAllClubs] = useState<IClub[]>([]);

  useEffect(() => {
    if (!!clubs.all) {
      setAllClubs(Object.values(clubs.all));
    }
  }, [clubs]);

  return (
    <>
      {allClubs.map(club => (
        <EventToday key={club.id} clubId={club.id} />
      ))}
    </>
  );
};

export default AllClubsEventToday;
